module.exports = __webpack_public_path__ + "img/logo-adesa.9f4ac638.png";